import * as yup from "yup";

export interface CvFormDataErrors {
  required: string;
  email: string;
  fileRequired: string;
  fileSize: string;
  phone: string;
  gdprRequired: string;
}

const maxFileSize = 7168 * 1000; 

export const cvFormDataValidationSchema = (error: CvFormDataErrors) =>
  yup
    .object()
    .shape({
      name: yup.string().required(error.required),
      email: yup
        .string()
        .test("required", error.required, (value) => !!value)
        .email(error.email),
      phoneNumber: yup
        .string()
        .test("required", error.required, (value) => !!value)
        .test(
          "type",
          error.phone,
          (value) => value != undefined && !isNaN(Number(value))
        )
        .test(
          "length",
          error.phone,
          (value) => value != undefined && value.length >= 8
        ),
      gdpr: yup.bool().oneOf([true], error.gdprRequired),
      files: yup
        .mixed()
        .test("required", error.fileRequired, (value) => value && value.length)
        .test(
          "size",
          error.fileSize,
          (value) => value && value.length && value[0].size <= maxFileSize
        ),
    })
    .required();
